import { User } from 'shared/generated-models';

export const getInitials = (user?: User) => {
	if (!user) return '';
	return `${user.first_name![0]}${user.last_name![0]}`;
};
